import React from 'react'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import {RiTwitterXFill} from "react-icons/ri"
function HeaderSocials() {
  return (
    <div className='header__socials'>
        <a href='https://www.linkedin.com/in/amaan-siddiqui-4512a2134' target='blank'><LinkedInIcon/></a>
        <a href='https://github.com/glennex' target='blank'><GitHubIcon/></a>
        <a href='https://twitter.com/__Amaan__a' target='blank'><RiTwitterXFill/></a>
      
    </div>
  )
}

export default HeaderSocials
